var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-section',{attrs:{"id":"what-ive-done"}},[_c('abstract-3'),_c('core-heading',[_vm._v("What I've done")]),_c('v-col',{attrs:{"cols":"12"}},[_c('project')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }